import { render, staticRenderFns } from "./Auftraege_Freigabe_Geschlossen.vue?vue&type=template&id=7215d5d5&scoped=true"
import script from "./Auftraege_Freigabe_Geschlossen.vue?vue&type=script&lang=js"
export * from "./Auftraege_Freigabe_Geschlossen.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../home/zarzar/Documents/public-solution/bis-office/web/auftragsbuch/node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7215d5d5",
  null
  
)

export default component.exports